<template>
    <div class="labels-wrap">

        <div v-if="is_load" class="labels-loading">
            <Info_field title="Loading labels..." />
        </div>

        <div v-else>
            <!-- Tabs -->
            <div class="labels-tabs" v-if="tabs.length > 0">
                <button
                    v-for="tab in tabs"
                    :key="tab.key"
                    type="button"
                    class="labels-tab"
                    :class="{ active: activeTab === tab.key }"
                    @click="activeTab = tab.key"
                >
                    {{ tab.title }}
                    <span class="labels-tab-count">
                        {{ tab.selected }}/{{ tab.count }}
                    </span>
                </button>
            </div>

            <!-- List -->
            <div class="labels-list">
                <button
                    v-for="label in filteredLabels"
                    :key="label"
                    type="button"
                    class="label-row"
                    :class="{ 'is-active': isActive(label) }"
                    @click="toggleLabel(label)"
                >
                    <div class="label-left">
                        <div class="label-title">{{ formatLabel(label) }}</div>
                        <div class="label-code">{{ label }}</div>
                    </div>

                    <div class="label-right" @click.stop>
                        <input
                            class="label-check d-none"
                            type="checkbox"
                            :checked="isActive(label)"
                            readonly
                        />
                    </div>
                </button>

                <div v-if="filteredLabels.length === 0" class="labels-empty">
                    Нет лейблов в этой группе
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Info_field from "../../../../sys/info_field.vue";

export default {
    name: "product_labels",
    components: { Info_field },
    props: {
        cur_idx: {
            type: Number,
            default: 0
        },

        items: {
            type: Array,
            default: () => []
        },

        hidden_groups: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            allowed_labels: [],
            label_groups: {},
            activeTab: 'system',
            is_load: false,

            // подписи табов (если захочешь — можно тоже отдавать с бэка)
            tabTitles: {
                system: 'System',
                diet: 'Diet',
                spicy: 'Spicy',
                restrictions: 'Restrictions',
                alcohol_nicotine: 'Alcohol/18+',
                drinks: 'Drinks',
                cooking: 'Cooking',
                audience: 'Audience',
                contains: 'Contains',
                marketing: 'Marketing',
                logistics: 'Logistics',
                other: 'Other'
            }
        };
    },

    created() {
        this.load_allowed_labels();
    },

    computed: {
        // Собираем tabs из label_groups, плюс Other (то что не попало ни в одну группу)
        tabs() {
            const groups = this.buildGroupsWithOther();
            const hiddenGroups = new Set(this.hidden_groups || []);

            const keys = Object.keys(this.tabTitles)
                .filter(groupName => {
                    return (
                        !hiddenGroups.has(groupName) &&
                        Array.isArray(groups[groupName]) &&
                        groups[groupName].length > 0
                    );
                });

            if (
                keys.length > 0 &&
                (!this.activeTab || !keys.includes(this.activeTab))
            ) {
                this.activeTab = keys[0];
            }

            return keys.map(groupName => {
                const labels = groups[groupName] || [];

                return {
                    key: groupName,
                    title: this.tabTitles[groupName] || groupName,
                    count: labels.length,
                    selected: labels.filter(label => this.isActive(label)).length
                };
            });
        },

        filteredLabels() {
            const groups = this.buildGroupsWithOther();
            return groups[this.activeTab] || [];
        }
    },

    methods: {
        async load_allowed_labels() {
            this.allowed_labels = [];
            this.label_groups = {};
            this.is_load = true;

            const url = '/internal/v1/catalog/products/allowed_labels';

            try {
                const { data } = await api.get(url);

                this.is_load = false;

                if (data.status === "operation_success") {
                    const payload = data.data || {};
                    this.allowed_labels = payload.allowed_labels || [];
                    this.label_groups = payload.label_groups || {};
                }
            } catch ({ response }) {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response?.data?.message || 'Request error',
                    type: "danger",
                    title: response?.data?.status || 'error'
                });
            }
        },

        // groups + other, и одновременно фильтруем только теми labels что разрешены API
        buildGroupsWithOther() {
            const allowedSet = new Set(this.allowed_labels || []);

            // нормализуем группы с бэка (и фильтруем по allowed)
            const groups = {};
            Object.keys(this.label_groups || {}).forEach(k => {
                const list = Array.isArray(this.label_groups[k]) ? this.label_groups[k] : [];
                groups[k] = list.filter(l => allowedSet.has(l));
            });

            // other = те, которых нет ни в одной группе
            const known = new Set();
            Object.values(groups).forEach(arr => arr.forEach(l => known.add(l)));

            const other = (this.allowed_labels || []).filter(l => !known.has(l));
            groups.other = other;

            return groups;
        },

        isActive(label) {
            return Array.isArray(this.items) && this.items.some(i => i && i.param_val === label);
        },

        toggleLabel(label) {
            const current = Array.isArray(this.items) ? this.items : [];
            const exists = current.find(i => i && i.param_val === label);

            let updated;
            if (exists) {
                updated = current.filter(i => i && i.param_val !== label);
            } else {
                updated = [
                    ...current,
                    {
                        id: 0,
                        client_id: null,
                        product_id: null,
                        group_type: 'labels',
                        param_name: null,
                        param_val: label
                    }
                ];
            }

            this.$emit('change_extra', updated, 'labels');
        },

        formatLabel(label) {
            return (label || '')
                .replace(/_/g, ' ')
                .replace(/\b\w/g, l => l.toUpperCase());
        }
    }
};
</script>

<style scoped>
.labels-tabs{
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 10px;
}

.labels-tab{
    border: 1px solid #e9ecef;
    background: #fff;
    padding: 6px 10px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.labels-tab.active{
    background: #f3f0ff;
    border-color: #d0bfff;
}

.labels-tab-count{
    font-size: 12px;
    color: #868e96;
}

.labels-list{
    border: 1px solid #e9ecef;
    border-radius: 8px;
    overflow: hidden;
}

.label-row{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 10px 12px;
    background: #fff;
    border: 0;
    border-bottom: 1px solid #f1f3f5;

    text-align: left;
    cursor: pointer;
}

.label-row:last-child{ border-bottom: 0; }
.label-row:hover{ background: #f8f9fa; }
.label-row.is-active{ background: #f3f0ff; }

.label-left{ min-width: 0; }
.label-title{ font-size: 14px; font-weight: 600; color: #212529; }
.label-code{ font-size: 12px; color: #868e96; margin-top: 2px; }

.label-right{ display: flex; align-items: center; padding-left: 12px; }
.label-check{ width: 16px; height: 16px; pointer-events: none; }

.labels-empty{
    padding: 12px;
    font-size: 13px;
    color: #868e96;
}
</style>
